import { observer } from "mobx-react-lite";
import { type ReactNode, useEffect, useState } from "react";

import { Loader } from "@/components/atoms";
import { rootStore } from "@/store/RootStore";

import { initializeAuth } from "./authInitializer";

interface AuthInitializerProps {
  children: ReactNode;
}

export const AuthInitializer = observer(
  ({ children }: AuthInitializerProps) => {
    const [isReady, setIsReady] = useState(rootStore.authStore.isInitialized);

    useEffect(() => {
      if (rootStore.authStore.isInitialized) {
        return;
      }

      initializeAuth().finally(() => {
        setIsReady(true);
      });
    }, []);

    if (!isReady) {
      return <Loader fullscreen />;
    }

    return <>{children}</>;
  }
);
